import React, { useRef, useState } from 'react';

import cn from '../../lib/classNames';

import Advantage from './Advantage/Advantage';
import EmpowerYourTeam from './EmpowerYourTeam/EmpowerYourTeam';
import EquipYourPeople from './EquipYourPeople/EquipYourPeople';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import MenuNav from './MenuNav/MenuNav';
import ProtectYourPeople from './ProtectYourPeople/ProtectYourPeople';
import SuperiorRiskIntelligence from './SuperiorRiskIntelligence/SuperiorRiskIntelligence';
import TravelRiskIntelligence from './TravelRiskIntelligence/TravelRiskIntelligence';
import TrySafeXploreAIForPersonalUse from './TrySafeXploreAIForPersonalUse/TrySafeXploreAIForPersonalUse';
import WhySafeExplore from './WhySafeExplore/WhySafeExplore';

import styles from './BusinessEditionPage.module.scss';

export type MenuItemType = {
	id: string;
	label: string;
	ref: React.RefObject<HTMLDivElement>;
};

export default function BusinessEditionPage() {
	const homeRef = useRef<HTMLDivElement>(null);
	const protectRef = useRef<HTMLDivElement>(null);
	const advantageRef = useRef<HTMLDivElement>(null);
	const whyRef = useRef<HTMLDivElement>(null);

	const [showDemoButton, setShowDemoButton] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	const menuItems: MenuItemType[] = [
		{ id: 'home', label: 'Home', ref: homeRef },
		{ id: 'protect', label: 'Protect Anywhere', ref: protectRef },
		{ id: 'advantage', label: 'Our Advantage', ref: advantageRef },
		{ id: 'why', label: 'Why Safe-xplore?', ref: whyRef },
	];

	return (
		<div className={cn(styles['business-edition-page'])}>
			<MenuNav
				classPageContent={styles.content}
				menuItems={menuItems}
				showDemoButton={!showDemoButton}
				isLoading={isLoading}
			/>
			<div className={styles['page-content']}>
				<Header
					ref={homeRef}
					classPageContent={styles.content}
					onDemoButtonVisibilityChange={setShowDemoButton}
					onLoadingComplete={setIsLoading}
				/>
				<ProtectYourPeople ref={protectRef} classPageContent={styles.content} />
				<EquipYourPeople classPageContent={styles.content} />
				<Advantage ref={advantageRef} classPageContent={styles.content} />
				<EmpowerYourTeam classPageContent={styles.content} />
				<WhySafeExplore ref={whyRef} classPageContent={styles.content} />
				<SuperiorRiskIntelligence classPageContent={styles.content} />
				<TrySafeXploreAIForPersonalUse classPageContent={styles.content} />
				<TravelRiskIntelligence />
				<Footer classPageContent={styles.content} />
			</div>
		</div>
	);
}
